import styled from "styled-components";
import Caption from "./Caption.js";
const CaptionMedium = styled(Caption)`
  font-weight: ${({ theme })=>theme.fonts.captionMedium.fontWeight};
`;
export default CaptionMedium;
